import React from 'react';
import SectionFAQ from './SectionFAQ'


const FAQPage = () => {
    return <SectionFAQ />
}

export default FAQPage